import { Component, OnInit } from '@angular/core';
import {MessageService } from 'primeng/api';
import {Router, ActivatedRoute } from '@angular/router';
import { Messages } from '@app/constants/constant';
import * as $ from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { CandidateFeedbackEvaluationService } from '@app/services/candidate-evaluation-feedback.service';
import { HttpClient } from '@angular/common/http';
import { ConfirmationService } from 'primeng/api';
import { InterviewStepStatusService } from '@app/services/interviewstep-status.service';
import { SaveCandidateFeedbackEvaluationService } from '@app/services/save-candidate-evaluation-feedback.service';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-candidate-evaluation',
  templateUrl: './candidate-evaluation.component.html',
  styleUrls: ['./candidate-evaluation.component.css']
})


export class CandidateEvaluationComponent implements OnInit {
  evaluationData: any = {};
  recommendationOptions: any;
  recommendation: any;
  CandidateOptions:any;
  CandidateStatus:any;
  interviewStepId:any;
  pageSize: number = 100;
  first: number = 0;
  additionalRemarkRequired:boolean=false;
  user :any;
  feedbackdisabled:boolean=false
  disabledOtherFields:boolean=false;
  removeSubmittedCondition:boolean=false;
  showOnlyFromViewScheduledInterviewListDashboard:boolean=false;
  recuriterChangeInterviewStatusId:any;
  comeFromViewInterviewScheduledInterviewList:boolean=false;
  interviewersString:any;
  mappingId:any;
  ratingMandatory:boolean=false;
  switchtemplate:boolean=false;
  disableSwitchFeature:boolean=false;
  strongAreasMandatory:boolean=false;
  fitmentRecommendationMandatory:boolean=false;
  pointsFocusedMandatory:boolean=false;
  fitmentPotentialMandatory:boolean=false;
  improvementAreasMandatory:boolean=false;
  recuriterFeedbackMandatory:boolean=false;
  changeRecommandation:boolean=false;
  recommendationMandatory:boolean=false;
  isinterviewrDashboardRedirect:number = 0;
  displayFeedback :boolean = false;
  jobId:any;
  ratingList: any;
  constructor(
    private confirmationService: ConfirmationService,
    private _candidateEvaluationFeedback: CandidateFeedbackEvaluationService,
    private _saveCandidateEvaluationFeedbackService:SaveCandidateFeedbackEvaluationService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private _toastService: MessageService,
    private _router: Router,
    private _interviewStepStatusService:InterviewStepStatusService,
    private route: ActivatedRoute 

  ) {

  }
  ngOnDestroy() {
    // ...
    window.sessionStorage.interviewrDashboardRedirect = 0;
    localStorage.removeItem('history');
    localStorage.removeItem('interviewStepMappingId');
    localStorage.removeItem('interviewId');
  }

  
  ngOnInit() {
    localStorage.setItem("clearFilter","false");
    this.user = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser'))['user'] : '';
    if (history && history.state && history.state.data) {
      window.localStorage.interviewStepMappingId = history.state.data.interviewStepMappingId;
      window.localStorage.interviewId=history.state.data.interviewId;
      this.mappingId = history.state.data.interviewStepMappingId;
    }
    else{
      this.mappingId = window.localStorage.interviewStepMappingId;
    }

    this.isinterviewrDashboardRedirect = window.sessionStorage.interviewrDashboardRedirect;
    //window.sessionStorage.interviewrDashboardRedirect = 0;

    if(history && history.state && history.state.data && history.state.data.disabledOtherFields){
      window.localStorage.history=JSON.stringify(history.state.data);
      // feedbackdisabled variable are use to diabled submit and draft button and disable all field when comes from view interview scheduled dashboard and click on view feedback and in case of edit feeback visible submit or draft button and editable Recommandation, Candidate Status and Recuriter Feedback field.
      this.feedbackdisabled = history.state.data.feedbackdisabled;
      // disabledOtherFields variable are use to editable only Recommandation, Candidate Status and Recuriter Feedback field when comes from view interview scheduled dashboard and click on view feedback/edit feedback.
      this.disabledOtherFields=history.state.data.disabledOtherFields;
      //removeSubmittedCondition variable are use to removeSubmmitedCondition means if we submit feedback through interview dashboard both submit and draft button will be disabled 
      //but when comes from view scheduled interview list and click on view feedback this check will  be remove user can edit feedback and can submit.
      this.removeSubmittedCondition=true;
      //showOnlyFromViewScheduledInterviewListDashboard variable are use to show Candidate status and Recuriter feedback field when comes from view scheduled interview dashboard.
      this.showOnlyFromViewScheduledInterviewListDashboard=true;
      //comeFromViewInterviewScheduledInterviewList variable are use to navigate again when click on draft and submit button when comes from view scheduled interview dashboard.
      this.comeFromViewInterviewScheduledInterviewList=true;
      this.jobId=history.state.data.jobId;
    }
    else{
      //if we refresh the page then get all detail from localstorage.
      if (!history.state || !history.state.data ) {
        if(window.localStorage.history){
          history.state.data=JSON.parse(window.localStorage.history);
        }
        if(history && history.state && history.state.data && history.state.data.disabledOtherFields){
          this.feedbackdisabled = history.state.data.feedbackdisabled;
          // disabledOtherFields variable are use to editable only Recommandation, Candidate Status and Recuriter Feedback field when comes from view interview scheduled dashboard and click on view feedback/edit feedback.
          this.disabledOtherFields=history.state.data.disabledOtherFields;
          //removeSubmittedCondition variable are use to removeSubmmitedCondition means if we submit feedback through interview dashboard both submit and draft button will be disabled 
          //but when comes from view scheduled interview list and click on view feedback this check will  be remove user can edit feedback and can submit.
          this.removeSubmittedCondition=true;
          //showOnlyFromViewScheduledInterviewListDashboard variable are use to show Candidate status and Recuriter feedback field when comes from view scheduled interview dashboard.
          this.showOnlyFromViewScheduledInterviewListDashboard=true;
          //comeFromViewInterviewScheduledInterviewList variable are use to navigate again when click on draft and submit button when comes from view scheduled interview dashboard.
          this.comeFromViewInterviewScheduledInterviewList=true;
          this.jobId=history.state.data.jobId;
        }
        this.mappingId= window.localStorage.interviewStepMappingId;
      }
    }
    this.getApiCall(this.mappingId,null);

    this._interviewStepStatusService.read(this.isinterviewrDashboardRedirect == 0 ?"true":"false", "interview-step-status/filtered-interview-step-status").subscribe(
      res => {
        this.recommendationOptions = res;
        console.log("options", res)
      });  
      this.ratingList = [
        { value: 0, label: 'NA' },
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' }
      ]
 
  }

  getApiCall(mappingId,StepId){
    this.http.get(environment.apiUrl+Messages.endpoint.candidate_evaluation_feedback+mappingId+"/"+StepId).toPromise().then(res=>{
      this.evaluationData = res;
      if(this.evaluationData == undefined || this.evaluationData.evaluationCategories == undefined || this.evaluationData.evaluationCategories.filter(e=>e.evaluationSkills.length > 0).length == 0)
      {
        this.displayFeedback = true;
      }

      this.interviewersString=this.evaluationData.interviewer.map(data=>{
        return data.firstName+" "+data.lastName;
      }).join(',')
      this.interviewStepId=this.evaluationData.interviewStepId;
      this.recommendation = this.evaluationData.interviewStepStatus;
      this.CandidateStatus=this.evaluationData.candidateStatus
      if(this.recommendation && this.recommendation.id==5 && (this.evaluationData.additionalRemarks=="" || this.evaluationData.additionalRemarks==undefined) && this.disabledOtherFields==false && this.evaluationData.isSubmitted==0){
        this.additionalRemarkRequired=true;
      }

      if(this.evaluationData.isSubmitted!=undefined){
        this.disableSwitchFeature=true;
      }
      this.updateScoreAverage();
      this.updateCandidateStatus(this.recommendation);
  });
  }

  updateCandidateStatus(recommendation){
    this._candidateEvaluationFeedback.read(recommendation.id, "interview-status-mapping").subscribe(
      res => {
        this.CandidateOptions = res;
        console.log(res)
      });
   }

  updateScoreAverage() {
    let count = 0;
    let totalRating = 0;
    this.evaluationData.evaluationCategories.forEach(element => {
      element.evaluationSkills.forEach(skill => {
        if (skill.rating != null && skill.rating > 0) {
          totalRating += Number(skill.rating);
          count++;
        }
      });
      if (element.customEvaluationSkills) {
        element.customEvaluationSkills.forEach(customSkill => {
          if (customSkill.rating != null && customSkill.rating > 0) {
            totalRating += Number(customSkill.rating);
            count++;
          }
        })
      }
    })
    if(totalRating==0){
      this.evaluationData.scoreAverage = 0.0;
    }else{
      this.evaluationData.scoreAverage = Number(totalRating / count).toFixed(1);
    }
  }

  submit(isDraft?) {
    this.ratingMandatory=false;

    if(this.interviewStepId && this.interviewStepId!='3' && this.disabledOtherFields==false && !isDraft){
      if (this.evaluationData.strongAreas==undefined || this.evaluationData.strongAreas=='') {
        this.strongAreasMandatory=true;
      }else{
        this.strongAreasMandatory=false;
      }
      if (this.evaluationData.improvementAreas==undefined || this.evaluationData.improvementAreas=='') {
        this.improvementAreasMandatory=true;
      }else{
        this.improvementAreasMandatory=false;
      }
      if (this.evaluationData.fitmentPotential==undefined || this.evaluationData.fitmentPotential=='') {
        this.fitmentPotentialMandatory=true;
      }else{
        this.fitmentPotentialMandatory=false;
      }
      if (this.evaluationData.pointsFocused==undefined || this.evaluationData.pointsFocused=='') {
        this.pointsFocusedMandatory=true;
      }else{
        this.pointsFocusedMandatory=false;
      }
      if(this.checkValue() || this.evaluationData.strongAreas==undefined || this.evaluationData.strongAreas=='' 
      || this.evaluationData.improvementAreas==undefined || this.evaluationData.improvementAreas==''
      || this.evaluationData.fitmentPotential==undefined || this.evaluationData.fitmentPotential==''
      || this.evaluationData.pointsFocused==undefined || this.evaluationData.pointsFocused==''){
        return;
      }
    }else if(this.interviewStepId && this.interviewStepId=='3' && this.disabledOtherFields==false && !isDraft){
      if(this.evaluationData.fitmentRecommendation==undefined || this.evaluationData.fitmentRecommendation=='') {
        this.fitmentRecommendationMandatory=true;
      }else{
        this.fitmentRecommendationMandatory=false;
      }
      if (this.evaluationData.strongAreas==undefined || this.evaluationData.strongAreas=='') {
        this.strongAreasMandatory=true;
      }else{
        this.strongAreasMandatory=false;
      }
      if((this.checkValue() || (this.evaluationData.fitmentRecommendation==undefined || this.evaluationData.fitmentRecommendation=='') || this.evaluationData.strongAreas==undefined || this.evaluationData.strongAreas==''&& this.interviewStepId && this.interviewStepId=='3')){
        return;
      }
    }

    if(this.recuriterFeedbackMandatory && this.disabledOtherFields){
      return;
    }
    
    if(this.checkValue()){
      return;
    }

    if(this.switchtemplate){
      this.evaluationData.interviewStepId="1";
    }else{
      this.evaluationData.interviewStepId=this.interviewStepId;
    }

    if(!isDraft && !this.disabledOtherFields){
      if(this.evaluationData.interviewStepId=="1"){
        this.evaluationData.evaluationCategories.forEach(element => {
          element.evaluationSkills.forEach(skill => {
            if (skill.rating == null || skill.rating== undefined) {
              this.ratingMandatory=true;
              
            }
          });
         
     if(element.customEvaluationSkills){
        element.customEvaluationSkills.forEach(customSkill => {
          if(customSkill.rating== null || customSkill.rating==undefined){
            this.ratingMandatory=true;
          }
        });
      }
      });
     
    }
  }
  if(this.ratingMandatory){
  return;
  }
  
    if (history && history.state && history.state.data) {
      this.evaluationData.interviewStepMappingId = history.state.data.interviewStepMappingId;
      this.evaluationData.interviewId=history.state.data.interviewId;
    }else{
      this.evaluationData.interviewStepMappingId = window.localStorage.interviewStepMappingId;
      this.evaluationData.interviewId=window.localStorage.interviewId;
    }

    this.evaluationData.interviewStepStatusId = this.recommendation.id;
    
    if(this.recuriterChangeInterviewStatusId!=null && this.recuriterChangeInterviewStatusId!=undefined){
      this.evaluationData.interviewStatusId=this.recuriterChangeInterviewStatusId;
    }else if(this.recommendation.id == Messages.interviewStepStatusIds.Cancelled)
    {
      this.evaluationData.interviewStatusId = this.CandidateStatus.id;
    }
    else{

      this.evaluationData.interviewStatusId =  this.recommendation.id==Messages.interviewStepStatusIds.Rejected?
      Messages.interviewStatusIds.closed_Rejected:this.recommendation.id==Messages.interviewStepStatusIds.On_hold?
      Messages.interviewStatusIds.onHold:this.evaluationData.interviewStepId!='3' && this.recommendation.id==Messages.interviewStepStatusIds.Shortlisted?
      Messages.interviewStatusIds.waiting_for_schedule:this.evaluationData.interviewStepId=='3' && this.recommendation.id==Messages.interviewStepStatusIds.Shortlisted?
      Messages.interviewStatusIds.waiting_for_offer:Messages.interviewStatusIds.scheduled;
    }


    if(this.disabledOtherFields){
      this.evaluationData.sendMail=false;
    }else{
      this.evaluationData.sendMail=true;
    }
    this.updateScoreAverage();
    if (isDraft) {
      // Save and Draft
      this.spinner.show();
      this.evaluationData.isSubmitted = 0;
      this.evaluationData.loggedInUser = JSON.parse(localStorage.getItem("currentUser")).user.id
      this._saveCandidateEvaluationFeedbackService.create(this.evaluationData, 'interview/save-candidate-evaluation-form').subscribe(
        (res:any) => {
          this.spinner.hide();
          this._toastService.add({ severity: 'success', summary:Messages.draft_candidate_evaluation_feedback, detail: '' });
          this.disableSwitchFeature=true;
          if(this.comeFromViewInterviewScheduledInterviewList){
            if(res && res.job){
              this._router.navigateByUrl('/view-scheduled-interview-list/' + res.job.id);
            }
          }
        },
        (err) => {
          console.log(err)
        });

      return
    }

    // Submit
    this.confirmationService.confirm({
      header: "Confirmation",
      message: 'The feedback will not be modified after submission. Do you want to continue?',
      accept: () => {
        this.evaluationData.isSubmitted = 1;
        this.evaluationData.loggedInUser = JSON.parse(localStorage.getItem("currentUser")).user.id;
        this._saveCandidateEvaluationFeedbackService.create(this.evaluationData, 'interview/save-candidate-evaluation-form').subscribe(
          (res:any) => {
            this._toastService.add({ severity: 'success', summary:Messages.sumbit_candidate_evaluation_feedback, detail: '' });
            if(this.comeFromViewInterviewScheduledInterviewList){
              if(res && res.job){
                this._router.navigateByUrl('/view-scheduled-interview-list/' + res.job.id);
              }
            }else{
              this._router.navigateByUrl('/interview-dashboard');
            }           
          },
          (err) => {
            this.evaluationData.isSubmitted = 0;
            console.log(err)
            alert(err);
          });
      },
      reject: () => {
      }
    });
  }

  redirectToPreviousPage() {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 400);
    if(this.comeFromViewInterviewScheduledInterviewList){
        this._router.navigateByUrl('/view-scheduled-interview-list/'+this.jobId);
    }else{
      this._router.navigateByUrl('/interview-dashboard');
    }    
  }

  showHideForm(event) {
    let currentTarget = event.target;
    if (currentTarget.tagName === "SPAN") {
      currentTarget = currentTarget.parentElement;
    }
    let dataTarget = currentTarget.getAttribute("id");
    $(dataTarget).slideToggle();
    $(currentTarget).find(".fa").toggleClass("fa-chevron-down").toggleClass("fa-chevron-right");
  }

  removeSkill(event,categoryName) {
    $(event.target).removeClass('pi pi-times').addClass('pi pi-spin pi-spinner');
    let index = Number(event.target.getAttribute("id"));
    setTimeout(() => {
      this.evaluationData.evaluationCategories.forEach(element => {
        if(categoryName==element.name){
          element.customEvaluationSkills.splice(index, 1);
        }
      })
    }, 400);
  }

  addNewSkill(event,categoryName) {
    this.spinner.show();
    this.evaluationData.evaluationCategories.forEach(element => {
      if(categoryName==element.name){
        if (element.customEvaluationSkills === undefined) {
          element.customEvaluationSkills = [];
        }
        element.customEvaluationSkills.push(
          {
            groups: '',
            skills: '',
            rating: null,
            feedback: '',
            newlyAdded: true
          }
        )
      }
    })
    setTimeout(() => {
      this.spinner.hide();
    }, 400);

  }

  onRate(event) {
    if ((!this.disabledOtherFields && !this.evaluationData.isSubmitted)) {
      let currentTarget = event.target;
      let value = Number(currentTarget.getAttribute("value"));
      if (value === 0) {
        $(currentTarget).removeClass('pi-times-circle').addClass('pi-spin pi-spinner');
        setTimeout(() => {
          $(currentTarget).addClass('pi-times-circle').removeClass('pi-spin pi-spinner');
          updateRating();
        }, 400);
      } else {
        this.spinner.show();
        setTimeout(() => {
          this.spinner.hide();
          updateRating();
        }, 400);
      }
      const updateRating = () => {
        let targetElement = currentTarget.parentElement.parentElement;
        let targetField = targetElement.getAttribute("id");
        let field = targetField.split('.')[0];
        let skillId = targetField.split('.')[1];
        let categoryName=targetField.split('.')[2];
        if (field === "customEvaluationSkills") {
          this.evaluationData.evaluationCategories.forEach(element => {
            if(element.name==categoryName){
              if (element.customEvaluationSkills) {
                element.customEvaluationSkills[skillId].rating = value;
              }
            } 
          })
        }
        else {
          this.evaluationData.evaluationCategories.forEach(element => {
            if (element.name === field) {
              element.evaluationSkills.forEach(item => {
                if (item.evaluation_skills_id === skillId) {
                  item.rating = value;
                }
              })
            }
          })
        }
        this.updateScoreAverage();
      }
    }
  }

  RecommendationChange(data){
    this.recommendationMandatory=false;
    this.updateCandidateStatus(data);
    if(data.id==5  && (this.evaluationData.additionalRemarks=="" || this.evaluationData.additionalRemarks==undefined) && this.disabledOtherFields==false){
      this.additionalRemarkRequired=true;
    }else{
      this.additionalRemarkRequired=false;
    }

    if(this.disabledOtherFields){
      this.recuriterFeedbackMandatory=true;
      this.changeRecommandation=true;
    }else{
      this.recuriterFeedbackMandatory=false;
      this.changeRecommandation=false;
    }
  }

  interviewStatusIdChange(data){
    this.recuriterChangeInterviewStatusId=data.id
    if(this.disabledOtherFields){
      this.recuriterFeedbackMandatory=true;
      this.changeRecommandation=true;
    }else{
      this.recuriterFeedbackMandatory=false;
      this.changeRecommandation=false;
    }
  }

  additionalRemarksData(event){
    if(event=='' && this.recommendation.id==5){
      this.additionalRemarkRequired=true;
    }else{
      this.additionalRemarkRequired=false;
    }
  }

  recuriterFeedbackData(event){
    if(event=='' && this.changeRecommandation){
      this.recuriterFeedbackMandatory=true;
    }else{
      this.recuriterFeedbackMandatory=false;
    }
  }

  switchTemplate(event){
    this.ratingMandatory=false;
    if(event.checked){
      this.getApiCall(this.mappingId,"1");
      this.switchtemplate=true;
      //this.interviewStepId="1"
    }else{
      this.getApiCall(this.mappingId,null);
      //this.interviewStepId="2"
      this.switchtemplate=false;
    }
  }

  checkValue():boolean{
    if (this.recommendation && this.recommendationOptions.length>0 && this.recommendationOptions.some(e => e.id === this.recommendation.id)) {
      this.recommendationMandatory=false;
      return false;
    }
    this.recommendationMandatory=true;
    return true;
  }

  checkManditoryField(event){
    // if(event=='' && this.evaluationData.strongAreas==''){
    //   this.strongAreasMandatory=true;
    // }else{
    //   this.strongAreasMandatory=false;
    // }

    // if(event=='' && this.evaluationData.improvementAreas==''){
    //   this.improvementAreasMandatory=true;
    // }else{
    //   this.improvementAreasMandatory=false;
    // }

    // if(event=='' && this.evaluationData.fitmentPotential==''){
    //   this.fitmentPotentialMandatory=true;
    // }else{
    //   this.fitmentPotentialMandatory=false;
    // }

    // if(event=='' && this.evaluationData.pointsFocused==''){
    //   this.pointsFocusedMandatory=true;
    // }else{
    //   this.pointsFocusedMandatory=false;
    // }

    // if(event=='' && this.evaluationData.fitmentRecommendation=='' && this.interviewStepId && this.interviewStepId=='3'){
    //   this.fitmentRecommendationMandatory=true;
    // }else{
    //   this.fitmentRecommendationMandatory=false;
    // }
  }
   
//   downloadPDF() {
//   const collapses: any = document.querySelectorAll('#ceAccordion .collapse');

//   // Expand all categories
//   collapses.forEach((el: any) => {
//     el.setAttribute('data-old-class', el.className); 
//     el.classList.remove('collapse', 'hide');
//     el.classList.add('show');
//     el.style.display = 'block';
//   });

//   const element = document.getElementById('evaluationPDF');

//   html2canvas(element, { scale: 1.3, logging: false, useCORS: true }).then(canvas => {
//     const imgWidth = 210;
//     const pageHeight = 295;
//     const imgHeight = canvas.height * imgWidth / canvas.width;

//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4');

//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft > 0) {
//       position = heightLeft - imgHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save('Candidate-Evaluation.pdf');

//     // Restore original state
//     // collapses.forEach((el: any) => {
//     //   const oldClass = el.getAttribute('data-old-class');
//     //   el.className = oldClass;
//     //   el.style.display = '';
//     // });
//   });
// }

downloadPDF() {
  // Get all category cards
  const categories: any = document.querySelectorAll('#ceAccordion .card');

  categories.forEach((card: any) => {
    const tableBody = card.querySelector('tbody');
    if (tableBody) {
      // Check if table has any rows with actual data
      const hasData = Array.from(tableBody.querySelectorAll('tr')).some((row: any) => {
        const cells = Array.from(row.querySelectorAll('td, input, textarea, select'));
        return cells.some((cell: any) => {
          if (cell.tagName === 'TD' || cell.tagName === 'TEXTAREA' || cell.tagName === 'INPUT') {
            return cell.textContent.trim() !== '' || cell.value;
          }
          if (cell.tagName === 'SELECT') {
            return cell.value !== '';
          }
          return false;
        });
      });

      // Hide the table if it has no data
      if (!hasData) {
        card.style.display = 'none';
      } else {
        // Expand the card
        const collapseEl = card.querySelector('.collapse');
        if (collapseEl) {
          collapseEl.classList.remove('collapse', 'hide');
          collapseEl.classList.add('show');
          collapseEl.style.display = 'block';
        }
      }
    }
  });

  const element = document.getElementById('evaluationPDF');

  html2canvas(element, { scale: 1.3, logging: false, useCORS: true }).then(canvas => {
    const imgWidth = 210;
    const pageHeight = 295;
    const imgHeight = canvas.height * imgWidth / canvas.width;

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save('Candidate-Evaluation.pdf');

    // Optional: restore hidden cards
    categories.forEach((card: any) => {
      card.style.display = '';
    });
  });
}


}

